
export default {
  name: 'Search',

  methods: {
    openSearch: function () {
      this.$store.commit('search/setOpen', true);
    },
  },
};
